import { Directive, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IDataContext } from '../list/component.interface';
import { LocalDate } from '../../model/local-date';
import { LanguageService } from '../../service/language.service';

@Directive()
export class DateTimeComponentBase implements OnDestroy, IDataContext {
  constructor(languageService: LanguageService) {
    this._subscription = languageService.onLangChange.subscribe(e => this._onLangChange(e.lang));
    this.locale = languageService.currentLanguage;
  }

  @Input() value: Date;

  private _subscription: Subscription;
  set dataContext(newValue: any) {
    if (newValue instanceof Date) {
      this.value = newValue;
    } else if (newValue instanceof LocalDate) {
      this.value = newValue.toDate();
    } else if (typeof newValue === 'string') {
      this.value = new Date(newValue);
    } else if (!newValue) {
      this.value = null;
    } else {
      throw new Error('Invalid data type.');
    }
  }
  locale: string;

  private _onLangChange(lang: string) {
    this.locale = lang;
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }
}
